/* VYREXWEAR — Nova theme: productpagina (galerij, varianten, foto-wissel per kleur, sticky koopbalk). */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var formatMoney = function (cents) {
    return typeof window.vxFormatMoney === 'function' ? window.vxFormatMoney(cents) : '€' + (cents / 100).toFixed(2).replace('.', ',');
  };

  /* ---------- Productpagina ---------- */
  document.querySelectorAll('[data-product]').forEach(initProduct);

  function initProduct(root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product;
    try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    /* Teksten uit de thema-editor (sectie Productpagina) */
    var T = {
      atc: root.getAttribute('data-t-atc') || 'In winkelmand',
      soldout: root.getAttribute('data-t-soldout') || 'Uitverkocht',
      unavailable: root.getAttribute('data-t-unavailable') || 'Niet beschikbaar',
      copied: root.getAttribute('data-t-copied') || 'Link gekopieerd',
      copyPrompt: root.getAttribute('data-t-copy-prompt') || 'Kopieer deze link:'
    };

    var form = root.querySelector('[data-product-form]');
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var saveEl = root.querySelector('[data-save]');
    var atcBtns = document.querySelectorAll('[data-atc]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stickyVariant = document.querySelector('[data-sticky-variant]');
    var slidesWrap = root.querySelector('[data-slides]');
    var slides = root.querySelectorAll('[data-media-id]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    var counter = root.querySelector('[data-counter]');

    /* Galerij */
    function goTo(index, smooth) {
      if (!slidesWrap || !slides[index]) return;
      slidesWrap.scrollTo({ left: slides[index].offsetLeft, behavior: smooth === false || reduceMotion ? 'auto' : 'smooth' });
      setActive(index);
    }
    function setActive(index) {
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === index); t.setAttribute('aria-current', i === index ? 'true' : 'false'); });
      if (counter) counter.textContent = (index + 1) + ' / ' + slides.length;
    }
    function currentIndex() {
      if (!slidesWrap || !slidesWrap.clientWidth) return 0;
      return Math.round(slidesWrap.scrollLeft / slidesWrap.clientWidth);
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    if (slidesWrap) {
      var st;
      slidesWrap.addEventListener('scroll', function () {
        clearTimeout(st);
        st = setTimeout(function () { setActive(currentIndex()); }, 60);
      }, { passive: true });
    }
    root.querySelectorAll('[data-gallery-prev]').forEach(function (b) { b.addEventListener('click', function () { goTo(Math.max(0, currentIndex() - 1)); }); });
    root.querySelectorAll('[data-gallery-next]').forEach(function (b) { b.addEventListener('click', function () { goTo(Math.min(slides.length - 1, currentIndex() + 1)); }); });
    /* Inzoomen: alleen op desktop en pas na een klik, zodat de foto niet beweegt tijdens het scrollen */
    if (finePointer) {
      var unzoom = function () { slides.forEach(function (s) { s.classList.remove('is-zoomed'); }); };
      slides.forEach(function (s) {
        var img = s.querySelector('img');
        if (!img) return;
        var setOrigin = function (e) {
          var r = s.getBoundingClientRect();
          img.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
          img.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
        };
        s.addEventListener('click', function (e) { setOrigin(e); s.classList.toggle('is-zoomed'); });
        s.addEventListener('pointermove', function (e) { if (s.classList.contains('is-zoomed')) setOrigin(e); });
        s.addEventListener('pointerleave', function () { s.classList.remove('is-zoomed'); });
      });
      window.addEventListener('scroll', unzoom, { passive: true });
      if (slidesWrap) slidesWrap.addEventListener('scroll', unzoom, { passive: true });
    }
    function showMedia(mediaId) {
      if (!mediaId) return;
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) { goTo(i); return; }
      }
    }

    /* Hoeveelheid */
    root.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          v = b.hasAttribute('data-qty-minus') ? Math.max(1, v - 1) : v + 1;
          input.value = v;
        });
      });
    });

    /* Varianten */
    var optionInputs = root.querySelectorAll('[data-option-input]');
    /* Lancering: kleuren en maten bekijken mag, maar nog niets doorstrepen of op 'uitverkocht' zetten */
    var isLaunch = root.hasAttribute('data-launch');
    function selectedOptions() {
      var values = [];
      root.querySelectorAll('[data-option-group]').forEach(function (group, i) {
        var checked = group.querySelector('input:checked');
        values[i] = checked ? checked.value : null;
        var label = group.querySelector('[data-option-selected]');
        if (label && checked) label.textContent = checked.value;
      });
      return values;
    }
    function findVariant(values) {
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var match = true;
        for (var j = 0; j < values.length; j++) {
          if (v.options[j] !== values[j]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }
    function markAvailability(values) {
      if (isLaunch) return;
      root.querySelectorAll('[data-option-group]').forEach(function (group, gi) {
        group.querySelectorAll('[data-option-input]').forEach(function (input) {
          var test = values.slice();
          test[gi] = input.value;
          var v = findVariant(test);
          var pill = input.nextElementSibling;
          if (pill) pill.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function updateButtons(variant) {
      if (isLaunch) return;
      atcBtns.forEach(function (b) {
        var label = b.querySelector('[data-atc-label]') || b;
        if (!variant) {
          b.disabled = true; label.textContent = T.unavailable;
        } else if (!variant.available) {
          b.disabled = true; label.textContent = T.soldout;
        } else {
          b.disabled = false; label.textContent = b.getAttribute('data-label-default') || T.atc;
        }
      });
    }
    function onChange() {
      var values = selectedOptions();
      var variant = findVariant(values);
      markAvailability(values);
      updateButtons(variant);
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      var priceText = formatMoney(variant.price);
      if (priceEl) priceEl.textContent = priceText;
      if (stickyPrice) stickyPrice.textContent = priceText;
      if (stickyVariant) stickyVariant.textContent = variant.title === 'Default Title' ? '' : variant.title;
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) { compareEl.hidden = !onSale; if (onSale) compareEl.textContent = formatMoney(variant.compare_at_price); }
      if (saveEl) {
        saveEl.hidden = !onSale;
        if (onSale) saveEl.textContent = '-' + Math.round((1 - variant.price / variant.compare_at_price) * 100) + '%';
      }
      var drop = root.querySelector('[data-drop]');
      if (drop) {
        drop.hidden = !onSale;
        if (onSale) {
          var dp = drop.querySelector('[data-drop-pct]'), ds = drop.querySelector('[data-drop-save]'), dw = drop.querySelector('[data-drop-was]');
          if (dp) dp.textContent = Math.round((1 - variant.price / variant.compare_at_price) * 100) + '%';
          if (ds) ds.textContent = formatMoney(variant.compare_at_price - variant.price);
          if (dw) dw.textContent = formatMoney(variant.compare_at_price);
        }
      }
      if (variant.featured_media) showMedia(variant.featured_media.id);
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      root.dispatchEvent(new CustomEvent('vx:variant-change', { detail: { variant: variant }, bubbles: true }));
    }
    /* Kleur gekozen terwijl de foto buiten beeld is (telefoon): even terugschuiven zodat je de nieuwe kleur ziet,
       maar zo dat de kleur- en maatknoppen in beeld blijven. */
    function showPhotoIfHidden() {
      var media = slidesWrap || root.querySelector('[data-media-id]');
      if (!media) return;
      var r = media.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var head = (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10) || 70) + 8;
      var visible = Math.min(r.bottom, vh) - Math.max(r.top, head);
      if (visible >= r.height * 0.35) return;
      var targetBottom = head + (vh - head) * 0.42;
      var dy = r.bottom - targetBottom;
      if (Math.abs(dy) < 8) return;
      window.scrollTo({ top: Math.max(0, window.pageYOffset + dy), behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    optionInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        onChange();
        var group = input.closest('[data-option-group]');
        if (group && group.querySelector('.pill__sw')) setTimeout(showPhotoIfHidden, 60);
      });
    });
    if (optionInputs.length) {
      var initValues = selectedOptions();
      markAvailability(initValues);
      var initVariant = findVariant(initValues);
      if (initVariant && initVariant.featured_media) {
        for (var k = 0; k < slides.length; k++) {
          if (String(slides[k].getAttribute('data-media-id')) === String(initVariant.featured_media.id)) {
            goTo(k, false);
            break;
          }
        }
      }
    }

    /* Sticky koopbalk */
    var mainAtc = root.querySelector('[data-atc-main]');
    var sticky = document.querySelector('[data-sticky-atc]');
    if (mainAtc && sticky && 'IntersectionObserver' in window) {
      var footer = document.querySelector('.vx-footer');
      var mainVisible = true, footerVisible = false;
      var update = function () { sticky.classList.toggle('is-visible', !mainVisible && !footerVisible); };
      new IntersectionObserver(function (en) {
        mainVisible = en[0].isIntersecting || en[0].boundingClientRect.top > 0;
        update();
      }).observe(mainAtc);
      if (footer) new IntersectionObserver(function (en) { footerVisible = en[0].isIntersecting; update(); }).observe(footer);
      var stickyBtn = sticky.querySelector('[data-sticky-submit]');
      if (stickyBtn && form) {
        stickyBtn.addEventListener('click', function () {
          if (form.requestSubmit) { form.requestSubmit(); } else { form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true })); }
        });
      }
    }

    /* Terug-op-voorraad: alleen tonen bij een uitverkochte kleur/maat */
    var restock = root.querySelector('[data-restock]');
    if (restock) {
      var rTags = restock.querySelector('[data-restock-tags]');
      var rName = restock.querySelector('[data-restock-variant]');
      var done = restock.querySelector('[data-restock-done]');
      if (done) { restock.hidden = false; }
      root.addEventListener('vx:variant-change', function (e) {
        var v = e.detail && e.detail.variant;
        if (done) return;
        restock.hidden = !v || v.available;
        if (!v) return;
        if (rName) rName.textContent = v.title;
        if (rTags) rTags.value = 'terug-op-voorraad, voorraad: ' + (rTags.getAttribute('data-product-title') || product.title) + ' – ' + v.title;
      });
    }

    /* Delen: deelmenu van de telefoon, anders link kopiëren */
    root.querySelectorAll('[data-share]').forEach(function (b) {
      var label = b.querySelector('[data-share-label]');
      var original = label ? label.textContent : '';
      b.addEventListener('click', function () {
        var url = window.location.href.split('#')[0];
        var data = { title: b.getAttribute('data-share-title') || document.title, url: url };
        if (navigator.share) { navigator.share(data).catch(function () {}); return; }
        var done = function () {
          if (!label) return;
          label.textContent = T.copied;
          b.classList.add('is-done');
          setTimeout(function () { label.textContent = original; b.classList.remove('is-done'); }, 2200);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done, function () { window.prompt(T.copyPrompt, url); });
        } else {
          window.prompt(T.copyPrompt, url);
        }
      });
    });

    /* Maattabel */
    root.querySelectorAll('[data-open-dialog]').forEach(function (b) {
      b.addEventListener('click', function () {
        var d = document.getElementById(b.getAttribute('data-open-dialog'));
        if (d && d.showModal) d.showModal();
      });
    });
  }
})();
